import { FETCH_STOCK_SUMMARY_ACCESSIBILITY, FETCH_STOCK_SUMMARY_RFS, FETCH_STOCK_SUMMARY_TOTALSTOCK, FETCH_STOCK_SUMMARY_STOCKTYPES, FETCH_STOCK_SUMMARY_SKULIST, FETCH_STOCK_SUMMARY_ALLOCATED_PICKED } from "../types"

const INIT_STATE = {
    stockSummaryTotalStockData: null,
    stockSummaryRFSData: null,
    stockSummaryAccessibilityData: null,
    stockSummaryStockTypesData: null,
    stockSummarySkuListData: [],
    stockSummaryAllocatedPickedData: null
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_STOCK_SUMMARY_TOTALSTOCK: return { ...state, stockSummaryTotalStockData: action?.payload || null }
        case FETCH_STOCK_SUMMARY_RFS: return { ...state, stockSummaryRFSData: action?.payload || null }
        case FETCH_STOCK_SUMMARY_ACCESSIBILITY: return { ...state, stockSummaryAccessibilityData: action?.payload || null }
        case FETCH_STOCK_SUMMARY_STOCKTYPES: return { ...state, stockSummaryStockTypesData: action?.payload || [] }
        case FETCH_STOCK_SUMMARY_SKULIST: return { ...state, stockSummarySkuListData: action?.payload || [] }
        case FETCH_STOCK_SUMMARY_ALLOCATED_PICKED: return { ...state, stockSummaryAllocatedPickedData: action?.payload || null }

        default: return state
    }
}